// Mock data for ຮ້ານຄ້າຖອນ COD ລ່ວງໜ້າ
// Used while backend endpoints are still being built.
// Swap to real API by flipping USE_MOCK in ./api.js (or setting VUE_APP_USE_MOCK_COD=false).

const SEED_STORES = [
  { name: 'BUBER SHOP',      customer_tel: '96460888', customer_name: 'BUBER' },
  { name: 'HAL CENTER',      customer_tel: '76476162', customer_name: 'HAL CENTER' },
  { name: 'BUI SHOP',        customer_tel: '78081691', customer_name: 'BUI' },
  { name: 'ຮ້ານ DT-FASHION', customer_tel: '96829525', customer_name: 'DT Fashion' },
  { name: 'ຮ້ານ D&T SHOP',    customer_tel: '95906891', customer_name: 'D&T Shop' },
  { name: 'ຮ້ານ D&T GIOBAL',  customer_tel: '96773662', customer_name: 'D&T Global' },
  { name: 'ຮ້ານ KP SHOP',     customer_tel: '20991234', customer_name: 'KP' },
  { name: 'ຮ້ານ Lao Mart',    customer_tel: '20887766', customer_name: 'Lao Mart' },
  { name: 'ຮ້ານ N1 Store',    customer_tel: '20554433', customer_name: 'N1 Store' },
  { name: 'ຮ້ານ Phonethip',   customer_tel: '20336688', customer_name: 'Phonethip' },
];

const WITHDRAW_PERCENTS = [10, 20, 30];
const FEE_PERCENTS = [1, 2, 3];

function generateStores(total = 127) {
  const list = [];
  for (let i = 0; i < total; i++) {
    const seed = SEED_STORES[i % SEED_STORES.length];
    const dayOffset = (i % 28) + 1;
    const month = ((i % 12) + 1).toString().padStart(2, '0');
    const day = dayOffset.toString().padStart(2, '0');
    const hour = (i % 23).toString().padStart(2, '0');
    const minute = ((i * 7) % 60).toString().padStart(2, '0');

    list.push({
      id: i + 1,
      name: seed.name,
      customer_tel: seed.customer_tel,
      created_at: `2025-${month}-${day} ${hour}:${minute}:00`,
      is_active: i % 13 !== 0,
      withdraw_percent: WITHDRAW_PERCENTS[i % WITHDRAW_PERCENTS.length],
      fee_percent: FEE_PERCENTS[i % FEE_PERCENTS.length],
      customer: { id: 100 + i, name: seed.customer_name, tel: seed.customer_tel },
      completed_cod: 5000000 + (i * 137000) % 50000000,
      pending_cod: 500000 + (i * 53000) % 8000000,
    });
  }
  return list;
}

export const ADVANCE_COD_STORES = generateStores(127);

// Mock customer pool reused by the customer-search panel inside the modal.
export const ADVANCE_COD_CUSTOMERS = [
  { id: 201, name: 'Soudaphone', tel: '52576899' },
  { id: 202, name: 'Soudalath',  tel: '54623877' },
  { id: 203, name: 'soudalat',   tel: '55903388' },
  { id: 204, name: 'soudalath',  tel: '56112233' },
  { id: 205, name: 'soudany',    tel: '57889900' },
];

let nextId = 1000;
export function nextMockId() {
  return ++nextId;
}
